export const ListQueryKey = 'projectCommodityOrders';
export const DetailQueryKey = 'projectCommodityOrder';

export const Urls = {
  selectUrl: '/commodityOrder/list',
  updateUrl: '/commodityOrder/update',
  deleteUrl: '/commodityOrder/delete',
  createUrl: '/commodityOrder/create',
  detailUrl: '/commodityOrder/info',
};
